import { useLayoutEffect, useRef, useState } from 'react';

export const useTitleWhenTruncated = <Element extends HTMLElement>(label: string) => {
    const ref = useRef<Element>(null);
    const [title, setTitle] = useState<string | undefined>();

    useLayoutEffect(() => {
        const element = ref.current;

        if (!element) {
            return;
        }

        const updateTitle = () => {
            setTitle(element.scrollWidth > element.clientWidth ? label : undefined);
        };

        updateTitle();

        if (typeof ResizeObserver === 'undefined') {
            return;
        }

        const resizeObserver = new ResizeObserver(updateTitle);
        resizeObserver.observe(element);

        return () => {
            resizeObserver.disconnect();
        };
    }, [label]);

    return { ref, title };
};
